﻿window.cBuilderEmailWidgetTitre = function(option) {
    var Me = this

    if (typeof option.tag == 'undefined' && option.element != 'undefined') option.tag = option.element.attr("tag")

    this.mGetButton = function () {
        var $DivBt = $("<div class='widget state-hover' typewidget='dxwidgettitre' tag='" + option.tag + "'/>").css({
            "padding": "5px",
            "width": "80px",
            "height": "95px",
            "cursor": "move",
            "margin": "5px",
            border: "3px solid " + theme.backgroundColorTitle,
            "text-align": "center",
            "display": "inline-block"
        })

        var txt = "Paragraphe"
        var fontSize = ""
        switch (option.tag) {
            case "h1": txt = "Titre 1"; fontSize = "100"; break;
            case "h2": txt = "Titre 2"; fontSize = "80";break;
            case "h3": txt = "Titre 3"; fontSize = "60";break;
            case "h4": txt = "Titre 4"; fontSize = "40";break;
        }
        var $I = $("<i class='" + Me.icone + " dx-theme-accent-as-text-color' style='font-size:260%;height:50px;'><span style='font-size:" + fontSize + "%;'>" + option.tag[1] + "</span></i>").appendTo($DivBt)
        var $Div = $("<div style='font-family:barlow condensed;font-size:100%;height:calc(100% - 60px);display:flex;align-items:center;justify-content:center;line-height:1;'>" + txt + "</div>").appendTo($DivBt)
        $DivBt.attr("title", "Ajouter un titre dans votre email")
        return $DivBt
    }

    //this.mCreateElement = function () {
    //    option.element = $("<tr class='widget dxwidgettitre' tag='" + option.tag + "'>")
    //    $("<!-- DEBUT TITRE" + option.Tag + " -->").appendTo(option.element)
    //    var $Td = $("<td valign='top' style='word-break:break-word;with:100%;' width='100%' class='bodywidget tdwidget widgetheightauto'><" + option.tag + " style='font-size:inherit;font-weight:inherit;line-height:inherit;letter-spacing:inherit;margin:0;'></" + option.tag + "></td>").appendTo(option.element)
    //    var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty(option.tag)))
    //    for (var prop in jsonDuplik) jsonDuplik[prop] = ""
    //    $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))
    //    $("<!-- FIN TITRE" + option.Tag + " -->").appendTo(option.element)
    //}

    this.mCreateElement = function () {
        option.element = this.mGetElement()
    }

    this.mGetElement = function () {
        var ele = $("<tr class='widget dxwidgettitre' tag='" + option.tag + "'>")
        $("<!-- DEBUT TITRE" + option.tag + " -->").appendTo(ele)
        var $Td = $("<td valign='top' style='word-break:break-word;with:100%;' width='100%' class='bodywidget tdwidget widgetheightauto'></td>").appendTo(ele)
        var jsonDuplik = JSON.parse(JSON.stringify(option.dxBuilderEmailPage.mJsonCssGuideProperty(option.tag)))
        for (var prop in jsonDuplik) jsonDuplik[prop] = ""
        $Td.attr("jsoncssdatawidget", JSON.stringify(jsonDuplik))

        var $TablePaddingBorder = $("<table  border='0' cellspacing='0' cellpadding='0' style='width:100%'/>").appendTo($Td)
        var $Tr = $("<tr/>").appendTo($TablePaddingBorder)
        var $Td = $("<td class='contenuwidget tdpaddingborderwidget'/>").appendTo($Tr)
        $("<" + option.tag + " style='font-size:inherit;font-weight:inherit;line-height:inherit;letter-spacing:inherit;margin:0;'></" + option.tag + ">").appendTo($Td)

        $("<!-- FIN TITRE" + option.tag + " -->").appendTo(ele)
        return ele
    }

    this.nom = "Titre " + option.tag
    this.icone = "fas fa-t"

    this.mAddCtrlSaisie = function (contentElement) {
        contentElement.empty()

        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Texte titre:</td>").appendTo(contentElement)
        var oldTxt = option.parent.mGetContenuWidget().find(option.tag).text()
        contentElement.closest(".dx-item-content").css("overflow", "visible")
        $("<div/>").appendTo(contentElement).dxCtrlTxtEmoji({
            bddCtrl: option.bddCtrl,
            pickerPosition: "bottom",
            value: oldTxt,
            placeholder: "Texte du titre...",
            onValueChanged: function (value) {
                option.parent.mGetContenuWidget().find(option.tag).text(value)
                option.onValueChanged()
            },
            onLoad: function () {
            }
        }).dxCtrlTxtEmoji("instance")
    }

    this.mAddCtrlStyle = function (contentElement) {
        contentElement.empty()

        var jsonCssDataOriginalValue = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        var jsonCssData = {}
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty(option.tag)) {
            jsonCssData[prop] = ""
            if (typeof jsonCssDataOriginalValue[prop] != 'undefined') jsonCssData[prop] = jsonCssDataOriginalValue[prop]
        }
        //$("<br/>").appendTo(contentElement)
        $("<div style='width:1px;white-space:nowrap;font-size:120%;font-weight:bold;' class=''>Style du texte:</div>").appendTo(contentElement)
        $("<div/>").appendTo(contentElement).dxCtrlBuilderEmailStyleFont({
            dxBuilderEmailPage: option.dxBuilderEmailPage,
            tag:option.tag,
            value: jsonCssData,
            showAlign: false,
            allowDefaut: true,
            onValueChanged: function (e) {
                e.values.forEach(function (value) {
                    if (value.value.length > 0) { jsonCssDataOriginalValue[value.prop] = value.value }
                    else { delete jsonCssDataOriginalValue[value.prop] }
                })
                option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssDataOriginalValue))
                option.onValueChanged()
            }
        })
    }

    this.mRemoveStyle = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty(option.tag)) {
            delete jsonCssData[prop]
        }
        option.parent.mGetBodyWidget().attr("jsoncssdatawidget", JSON.stringify(jsonCssData))
        option.onValueChanged()
    }

    this.mUpdateCss = function () {
        var jsonCssData = JSON.parse(option.parent.mGetBodyWidget().attr("jsoncssdatawidget"))
        for (var prop in option.dxBuilderEmailPage.mJsonCssGuideProperty(option.tag)) {
            if (typeof jsonCssData[prop] != 'undefined' && jsonCssData[prop].length > 0) {
                option.parent.mGetBodyWidget().css(prop, jsonCssData[prop])
                //if (prop == "text-align") option.parent.mGetContenuWidget().find("td").css(prop, jsonCssData[prop])
            } else {
                option.parent.mGetBodyWidget().css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty(option.tag, prop))
                //if (prop == "text-align") option.parent.mGetContenuWidget().find("td").css(prop, option.dxBuilderEmailPage.mJsonCssGuideProperty(option.tag, prop))
            }
        }
    }

}